import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect } from 'react';
import VehiclesAvailableSoonerContext from '~/context/vdp/VehiclesAvailableSoonerContext';

export default function useSendVehiclesAvailableSooner() {
  const { trackEvent } = useContext(AnalyticsContext);
  const vehiclesAvailableSooner = useContext(VehiclesAvailableSoonerContext);

  useEffect(() => {
    if (!vehiclesAvailableSooner.isLoaded || vehiclesAvailableSooner.hasError) {
      return;
    }
    trackEvent('Vehicles Available Sooner', {
      vehicles: vehiclesAvailableSooner.data
    });
  }, [
    trackEvent,
    vehiclesAvailableSooner.data,
    vehiclesAvailableSooner.hasError,
    vehiclesAvailableSooner.isLoaded
  ]);
}
